<template>
    <i
        class="fa fa-lg pointer"
        :class="'fa-' + icon"
        @click.prevent="editInvoiceModal = true"
        :title="uLang('app.edit_type', { type: lang(`app.${type}_invoice`) })"
    >
        <portal to="modals" v-if="editInvoiceModal">
            <b-modal
                v-model="editInvoiceModal"
                :title="uLang('app.edit_type', { type: lang(`app.${type}_invoice`) })"
                size="lg"
                hide-footer
            >
                <edit-invoice-form
                    :invoice-id="invoiceId"
                    :type="type"
                    :override-endpoint="route(`invoices.${type}.update`, { invoice: invoiceId })"
                    @invoiceUpdated="handleInvoiceUpdated"
                />
            </b-modal>
        </portal>
    </i>
</template>

<script>
import { EditInvoiceForm } from '~/components/forms'

export default {
    name: 'EditCreditInvoiceButton',

    components: {
        EditInvoiceForm
    },

    props: {
        icon: {
            type: String,
            required: false,
            default: 'pencil',
        },
        invoiceId: {
            type: Number,
            required: true,
        },
        type: {
            type: String,
            required: true,
        }
    },

    data() {
        return {
            editInvoiceModal: false,
        }
    },

    methods: {
        handleInvoiceUpdated() {
            this.editInvoiceModal = false
        }
    }
}
</script>

<style>

</style>